module.exports = __webpack_public_path__ + "img/2.cf174bd3.jpg";